import { ModalBase } from './modal.component';
import { FC } from 'react';

export interface ModalProps {
  close: () => void;
}

interface ModalHocOptions {
  closeOnOverlayClick?: boolean;
  closeOnEscape?: boolean;
}

export const modalHoc = <T extends object>(
  Component: FC<T & ModalProps>,
  id: string,
  { closeOnOverlayClick = false, closeOnEscape = false }: ModalHocOptions = {},
) =>
  class ModalWrapper extends ModalBase<T> {
    constructor(data: T) {
      super(id || (data as { id?: string })?.id, data);
      this.closeOnOverlayClick = closeOnOverlayClick;
      this.closeOnEscape = closeOnEscape;
    }

    public renderModal = (): React.ReactNode => {
      return <Component {...this.getData()} close={this.close} />;
    };
  };
